import { ca } from '@cian/analytics';

import { trackShowNumberClick } from './analytics';
import { TAnalyticsMessagePayload } from '../../types';

type TEventType = 'event' | 'eventEbc' | 'eventEnrich';

export function eventHandler([eventType, eventParams]: TAnalyticsMessagePayload) {
  const { action, category, label, sc, products, page } = eventParams;

  if (category === 'Phones' && action === 'Open_listing') {
    trackShowNumberClick({ label, sc, products, page });
  } else {
    ca(eventType as TEventType, eventParams);
  }
}
